import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AccountService, UserRole } from 'services/account.service';
import { Observable, tap } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CoreUiGuard implements CanActivate {
  private accountService = inject(AccountService);
  private router = inject(Router);

  public canActivate(): Observable<boolean> {
    return this.accountService.getSelectedCompany$().pipe(
      map((company) => this.accountService.userRole !== UserRole.MSP || !!company),
      tap((canActivate) => {
        if (!canActivate) {
          this.router.navigate(['partner-portal']);
        }
      })
    );
  }
}
